/* eslint-disable no-restricted-syntax */
/**
 * Environment-aware logging utility.
 *
 * In production (VITE_ENV=prod) ALL console output is suppressed.
 * In every other environment all levels are available.
 *
 * Override with VITE_LOG_LEVEL in your .env file.
 * Valid values: "debug" | "info" | "warn" | "error" | "none"
 */

type LogLevel = "debug" | "info" | "warn" | "error" | "none";

const LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  none: 4,
};

const DEFAULT_LEVEL: LogLevel =
  import.meta.env.VITE_ENV === "prod" ? "none" : "debug";

const LOG_LEVEL: LogLevel =
  (import.meta.env.VITE_LOG_LEVEL as LogLevel) || DEFAULT_LEVEL;

const currentLevel = LEVELS[LOG_LEVEL] ?? LEVELS[DEFAULT_LEVEL];

const noop = (): void => {};

export const logger = {
  debug:
    currentLevel <= LEVELS.debug
      ? (...args: unknown[]): void => console.log(...args)
      : noop,
  info:
    currentLevel <= LEVELS.info
      ? (...args: unknown[]): void => console.log(...args)
      : noop,
  warn:
    currentLevel <= LEVELS.warn
      ? (...args: unknown[]): void => console.warn(...args)
      : noop,
  error:
    currentLevel <= LEVELS.error
      ? (...args: unknown[]): void => console.error(...args)
      : noop,
};
